var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 2.385a.245.245 0 0 1 .133-.216l2.003-1.083c.18-.097.408.022.408.213l.012 3.93c0 .11.08.208.195.238l1.78.48c.05.013.104.013.154 0l1.764-.478a.251.251 0 0 0 .194-.244l-.105-3.918c-.005-.193.223-.317.405-.221l2.06 1.085a.246.246 0 0 1 .137.212l.053 4.665a.25.25 0 0 1-.179.237l-2.902.963a.25.25 0 0 0-.178.233v5.504c-.569.415-2.264.407-2.82-.027v-5.48a.25.25 0 0 0-.174-.232l-2.714-.96a.25.25 0 0 1-.173-.23L4 2.386Zm11.59-1.19A.267.267 0 0 1 15.854 1h2.659c.127 0 .237.08.264.195l.984 4.08-1.298 3.032v5.678c-.516.377-2.018.366-2.522-.027v-5.65l-1.335-3.034.984-4.08Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.892 14.472c1.572.877 3.837.87 5.41 0v6.222c.036 3.11-5.374 3.04-5.41 0v-6.222Zm8.698 0c1.272.877 4.138.87 5.41 0v6.222c.037 3.11-5.374 3.04-5.41 0v-6.222Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.5bc270dd62205cd56ad1fe3eb80fe1d9.svg";
export { ForwardRef as ReactComponent };